export const getEnvValue = (key: string, defaultValue = '') =>
    process.env[key] ?? defaultValue;

export const isDevelopment = getEnvValue('NODE_ENV') === 'development';

export const isProduction = getEnvValue('NODE_ENV') === 'production';

export const version = getEnvValue('NX_VERSION');